import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';
import {modifyPageLayoutComponents} from '../../PageLayout';
import pageFooterTemplate from './footer';
import template from '../../../templates/Stones/AssignPricing/index.rt';
import pageHeaderTemplate from '../../../templates/Stones/AssignPricing/header.rt';
import pageMenuTemplate from './menu';
import {
  selectSearchTerm, getFilteredUpdatedStones
} from '../../../selectors';
import * as editorNames from '../../../constants/editorNames';
import * as actions from '../../../actions';
import {forceCheck} from 'react-lazyload';

const PAGE_SIZE = 18;

function mapStateToProps(state) {
  let updatedStones = getFilteredUpdatedStones(state);
  let enabledStones = [updatedStones.filter(us => us.fabricatorStoneData && us.fabricatorStoneData.enabled)]; //_.chunk(updatedStones.filter(us => us.fabricatorStoneData && us.fabricatorStoneData.enabled), PAGE_SIZE);
  const {auth, asCustomer} = state;
  let fabId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
  return {
    term: selectSearchTerm(state),
    enabledStones,
    totalPages: enabledStones.length,
    selectedStones: state.pricingPreset.selected,
    fabId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadPresets: () => dispatch(actions.pricingPresets.loadPresets()),
    fetchStones: () => dispatch(actions.loadAndFetchStones()),
    fetchFabSettings: (fabId) => dispatch(actions.getCustomerInfo(fabId, 'Fabricator', undefined, false)),
    setSearchTerm: (term) => dispatch(actions.setSearchTerm(term)),
    onLoadEditor: () => dispatch(actions.loadEditor(editorNames.STONE_SETUP)),
    onUnloadEditor: () => dispatch(actions.unloadEditor()),
    selectStone: (stone) => dispatch(actions.pricingPresets.selectStone(stone)),
    selectAllStones: () => dispatch(actions.pricingPresets.selectAllStones()),
    deselectAllStones: () => dispatch(actions.pricingPresets.deselectAllStones())
  };
}

class stoneAssignPricing extends React.Component {
  static propTypes = {
    fetchStones: PropTypes.func.isRequired,
    fetchFabSettings: PropTypes.func.isRequired,
    setSearchTerm: PropTypes.func.isRequired,
    onLoadEditor: PropTypes.func.isRequired,
    onUnloadEditor: PropTypes.func.isRequired
  };

  state = {
    page: 0
  };

  render = template;

  componentDidMount() {
    this.props.onLoadEditor();
    this.props.loadPresets()
      .then(() => this.props.fetchFabSettings(this.props.fabId))
      .then(this.props.fetchStones);
  }

  componentDidUpdate() {
    forceCheck();
    if(this.state.page >= this.props.enabledStones.length && this.state.page > 0) {
      this.setState({page: this.props.enabledStones.length - 1});
    }
  }

  componentWillUnmount() {
    this.props.setSearchTerm('');
    this.props.onUnloadEditor();
    this.props.deselectAllStones();
  }

  /**
   * Changes Manage Assign Pricing popup Page
   * @param {constants pricingPresets.PRICING_PRESET_(NEW/LIST/EDIT)} page
   */
  setPage = (page) => {
    this.setState({page: page});
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

const StoneAssignPricing = connector(stoneAssignPricing);
const StoneAssignPricingPageHeader = connector(pageHeaderTemplate);
const StoneAssignPricingMenu = connector(pageMenuTemplate);

export const StoneAssignPricingLayoutComponents = modifyPageLayoutComponents({
  pageHeader: StoneAssignPricingPageHeader,
  content: StoneAssignPricing,
  pageFooter: pageFooterTemplate,
  pageMenu: StoneAssignPricingMenu
});
